export enum ConsentType {
  GDPR = 'GDPR',
  TERMS_OF_SERVICE = 'TermsOfService',
}

export enum ConsentDecision {
  PARTIALLY_ACCEPTED = 'partially_accepted',
  ACCEPTED = 'accepted',
}
